import { useEffect } from 'react';
import { useUserNotifications } from '@/hooks/useUserNotifications';
import { useAuth } from '@/features/auth/hooks/useAuth';

/**
 * Manager component that handles global user WebSocket room join/leave.
 * Renders nothing - just manages the WebSocket connection lifecycle.
 *
 * Place this inside AuthProvider so it has access to user state.
 */
export const UserNotificationsManager = () => {
    const { on } = useUserNotifications();
    const { refetchUser } = useAuth();

    useEffect(() => {
        const unsubscribe = on('bidStatusChanged', () => {
            refetchUser();
        });

        return () => {
            unsubscribe();
        };
    }, [on, refetchUser]);

    return null;
};
